import type { ReactNode } from 'react'

interface PortfolioSubRowLayoutProps {
  badge: ReactNode
  range?: ReactNode
  mobileTopContent?: ReactNode
  balances: ReactNode
  aprText: string
  valueText: string
  rewards?: ReactNode
  actions?: ReactNode
  mobileRewardsLabel?: string
  mobileRewards?: ReactNode
  showRangeColumn?: boolean
  showRewardsPlaceholder?: boolean
  showActionPlaceholder?: boolean
}

export function PortfolioSubRowLayout({
  badge,
  range,
  mobileTopContent,
  balances,
  aprText,
  valueText,
  rewards,
  actions,
  mobileRewardsLabel,
  mobileRewards,
  showRangeColumn = false,
  showRewardsPlaceholder = true,
  showActionPlaceholder = true,
}: PortfolioSubRowLayoutProps) {
  return (
    <div>
      <div className="sm:hidden pl-6 pr-3 py-2 bg-[#222f42]">
        {mobileTopContent ? <div className="pb-2">{mobileTopContent}</div> : null}

        <div className="grid grid-cols-3 items-center gap-3">
          <div className="flex items-center">{badge}</div>
          <div className="text-xs text-kodiak-text-primary text-center">
            {aprText} <span className="text-kodiak-text-secondary">APR</span>
          </div>
          <div className="text-kodiak-text-primary font-medium text-xs text-right">{valueText}</div>
        </div>

        {mobileRewardsLabel && mobileRewards && (
          <div className="mt-2 flex items-start justify-between gap-2">
            <div className="text-kodiak-text-secondary text-xs">{mobileRewardsLabel}</div>
            <div className="min-w-0 text-right">{mobileRewards}</div>
          </div>
        )}

        {actions && <div className="mt-2 flex justify-end">{actions}</div>}
      </div>

      <div
        className={`hidden sm:grid items-center gap-4 py-2 pl-10 pr-6 bg-[#222f42] ${
          showRangeColumn ? '' : 'grid-cols-6'
        }`}
        style={
          showRangeColumn
            ? {
                gridTemplateColumns:
                  'minmax(0, 1.45fr) minmax(0, 150px) minmax(0, 1fr) minmax(0, 0.9fr) minmax(0, 0.9fr) minmax(0, 1fr) minmax(0, 0.8fr)',
              }
            : undefined
        }
      >
        <div className="flex items-center">{badge}</div>
        {showRangeColumn ? <div>{range ?? null}</div> : null}
        <div>{balances}</div>
        <div className="text-kodiak-text-primary text-right text-xs">{aprText}</div>
        <div className="text-kodiak-text-primary font-medium text-right text-xs">{valueText}</div>
        <div>
          {rewards ??
            (showRewardsPlaceholder ? <div className="text-kodiak-text-secondary text-right text-xs">—</div> : null)}
        </div>
        <div className="flex justify-end">
          {actions ?? (showActionPlaceholder ? <div className="text-kodiak-text-secondary text-xs">—</div> : null)}
        </div>
      </div>
    </div>
  )
}
